<template>
  <div class="flow-box">
    <!-- 流程连线 -->
    <template v-for="(step, index) in steps">
      <template v-if="index < steps.length - 1">
        <div
          :key="'l' + index"
          :class="{
            'flow-line': true,
            odd: index % 2 === 0,
            even: index % 2 === 1
          }"
        />
      </template>
    </template>


    <template v-for="(step, index) in steps">
      <div
        v-if="false"
        :key="'s' + index"
        class="flow-step"
        :style="[
          index % 2 === 0 ? oddStyle : evenStyle,
          { top: -30 + 75 * index + 'px' }
        ]" 
      >
        <div class="step-wrapper">
          <!-- 流程步骤 -->
          <flow-step
            :unexecuted="step.unexecuted"
            :step="step"
            :editable="editable"
            :checkable="checkable"
            :step-index="index"
            :selected="step.selected"
            @click.native="selectedStep(step,index)"
            ref="step" 
          />

          <!-- 步骤增加删除按钮 -->
          <div v-if="editable" class="step-buttons">
            <i
              v-if="index != 0"
              class="el-icon-remove step-button-remove"
              @click="stepRemove(index,step)"
            />
            <i
              v-if="index == steps.length - 1"
              class="el-icon-circle-plus step-button-add"
              @click="stepAdd"
            />
          </div>
        </div>
      </div>
    </template>


     <div class="flow-steps">
      <draggable v-bind="dragOptions" :disabled="!dragable" @start="drag = true" @end="drag = false" :list="steps">
        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
          <div :class="{'odd-wrapper':index%2==0,'even-wrapper':index%2==1,'step-wrapper':true}" v-for="(step, index) in steps" :key="'s'+index">
              <flow-step
                :unexecuted="step.unexecuted"
                :step="step"
                :editable="editable"
                :checkable="checkable"
                :step-index="index"
                :selected="step.selected"
                @click.native="selectedStep(step,index)"
                ref="step" 
              />

              <!-- 步骤增加删除按钮 -->
              <div v-if="editable" class="step-buttons">
                <i
                  v-if="index != 0"
                  class="el-icon-remove step-button-remove"
                  @click="stepRemove(index,step)"
                />
                <i
                  v-if="index == steps.length - 1"
                  class="el-icon-circle-plus step-button-add"
                  @click="stepAdd"
                />
              </div>

          </div>
        </transition-group>
      </draggable>
    </div>
  </div>
</template>

<script>
import FlowStep from '@/components/flow/step'
//import { nextTick } from 'q'
import draggable from "vuedraggable";

export default {
  name: '',
  components: { 'flow-step': FlowStep,draggable },
  mixins: [],
  props: {
    steps: {
      type: Array
    },
    /** 名称可编辑 */
    editable: {
      type: Boolean,
      default: true
    },
    /** 可勾选 */
    checkable: {
      type: Boolean,
      default: true
    },
    /** 拖拽排序 */
    dragable:{
      type:Boolean,
      default: false
    }
  },
  data() {
    return {
      drag:false
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 100,
        //group: "description",
        ghostClass: "ghost"
      }
    }
  },
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    stepAdd() {
      this.steps.push({ checked: true, selected: false })
      
      // 新增节点自动编辑状态
      this.$nextTick(()=>{
        if(this.$refs.step){
          this.$refs.step[this.$refs.step.length - 1].beginEdit();
        }

        // if(this.$el.parentElement){
        //   this.$el.parentElement.scrollTop = this.$el.parentElement.scrollHeight
        // }

        this.$emit('stepAdded')
      });
    },
    stepRemove(index, stepR) {
      this.steps.splice(index, 1)
      this.$emit('stepRemoved', index, stepR)
    },
    /** 鼠标点击选中后事件反馈 */
    selectedStep(step,index){
      let selectedList = this.steps.filter((item)=> {return item.selected});
      for(let i=0;i< selectedList.length ;i++){
        selectedList[i].selected = false;
      }
      this.steps[index].selected = true;
      this.$emit('selectedStep',step)
    },
    /** 选择某个step */
    selectStep(stepId){
      let selectedList = this.steps.filter((item)=> {return item.selected});
      for(let i=0;i< selectedList.length ;i++){
        selectedList[i].selected = false;
      }
      let selectingList = this.steps.filter((item)=>{return item.stepId == stepId});
      if(selectingList.length > 0)
      selectingList[0].selected = true;
      this.$emit('selectedStep',selectingList[0])
    },
    selectStepIndex(index){
      let selectedList = this.steps.filter((item)=> {return item.selected});


      for(let i=0;i< selectedList.length ;i++){
        selectedList[i].selected = false;
      }
      this.steps[index].selected = true;

      this.$emit('selectedStep',this.steps[index])
    }
  }
}
</script>
<style lang="scss" scoped>
// .flip-list-move {
//   transition: transform 0.5s;
// }

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.flow-box {
  width: 400px;
  //background-color: #ececec;
  min-height:1px;
  position: relative;
  margin-top: 60px;
  margin-bottom: 60px;

  .flow-line {
    height: 75px;
    //margin-bottom: -10px;

    &.odd {
      background: url(../../assets/flowlinenew-odd.png);
      background-repeat: no-repeat;
      background-position: 30% center;
      //background-size: contain;
      background-size: 50% 100% ;
    }
    &.even {
      background: url(../../assets/flowlinenew-even.png);
      background-repeat: no-repeat;
      background-position: 30% center;
      //background-size: contain;
      background-size: 50% 100% ;
    }
  }

  .flow-steps{
    width:100%;
    position: absolute;
    top:-40px;left:0;
    // padding-left: 80px;
    // box-sizing: border-box;
    cursor:move;

    .step-wrapper{
      height:75px;
      display:flex;
      align-items: center;
      
    }
    .odd-wrapper{
      //background-color: #029fe750;
      justify-content: flex-start;

    }
    .even-wrapper{
      //background-color:#f5a62350;
      justify-content:flex-end;
    }

    .step-buttons {
        width: 80px;
        font-size: 24px;
        display: flex;
        justify-content: space-around;

        .step-button-remove {
          color: #f5a623;
          cursor: pointer;
        }

        .step-button-add {
          color: #029fe7;
          cursor: pointer;
        }
      }
  }
}
</style>
